/**
 * Shuffle Judge.me reviews carousel on main page so reviews appear in random order on each load.
 * Waits for Judge.me content to load (async) then shuffles review items.
 */
(function () {
  function shuffleArray(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function tryShuffleReviews() {
    var carousel = document.querySelector('.jdgm-carousel-wrapper, .jdgm-carousel, [class*="jdgm-carousel"]');
    if (!carousel) return false;

    var items = carousel.querySelectorAll('.jdgm-carousel-item, .jdgm-rev, .swiper-slide');
    if (items.length < 2) return false;

    var shuffled = shuffleArray(Array.prototype.slice.call(items));
    var parent = items[0].parentNode;
    for (var k = 0; k < shuffled.length; k++) {
      parent.appendChild(shuffled[k]);
    }
    return true;
  }

  function init() {
    if (tryShuffleReviews()) return;

    var section = document.querySelector('#shopify-section-168250732864c005eb, [id*="168250732864c005eb"]');
    var target = section || document.body;

    var observer = new MutationObserver(function () {
      if (tryShuffleReviews()) observer.disconnect();
    });
    observer.observe(target, { childList: true, subtree: true });

    [500, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        if (tryShuffleReviews()) observer.disconnect();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
